<template>
  <LayoutErrorPrimary>
    <div :style="style.container">
      <HeaderLargePrimary
        :truncate="true"
        :style="style.header"
      >
        404: Page Not Found.
      </HeaderLargePrimary>
      <ImagePrimary
        :src="require('@img/robot.png')"
        :style="style.image"
      />
    </div>
  </LayoutErrorPrimary>
</template>

<script>
  import HeaderLargePrimary from '@modules/v2/header/header-large-primary'
  import ImagePrimary from '@modules/v2/image/image-primary'
  import LayoutErrorPrimary from '@modules/v2/layout/layout-error-primary'
  import { Layout } from '@js/styles'

  export default {
    name: 'Error404View',
    components: {
      HeaderLargePrimary,
      ImagePrimary,
      LayoutErrorPrimary,
    },
    data: function () {
      return {
        style: {
          container: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            flex: 1,
            height: '100%',
            padding: `${Layout.space.sm} ${Layout.space.lg} ${Layout.space.lg}`,
            width: '100%',
          },
          header: {
            justifyContent: 'center',
          },
          image: {
            maxWidth: '400px',
            margin: `${Layout.space.xl} 0`,
            width: 'fit-content',
          },
        },
      };
    },
  };
</script>
